// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__4srPY","gfeWrapper":"CalendarEvent_gfeWrapper__3V4uL"};